import { NetworkMember } from "../../../../../Redux/referral/types";
import {
  earningsStatusClass,
  formatEarningsCurrency,
  statusLabel,
} from "../../earningsAdapters";

interface Props {
  members: NetworkMember[];
}

const ReferralCommLevelTable = ({ members }: Props) => {

  return (
    <div className="ri-table-wrap ri-preserve-mobile-table ri-milestone-table-wrap">
      <div className="ri-mobile-table-note">
        Swipe horizontally to view complete table
      </div>
      <table className="ri-table ri-milestone-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>MEMBER</th>
            <th>PARTNER NETWORK ID</th>
            <th>REFERRING PARTNER ID</th>
            <th>REFERRAL UPLINER</th>
            <th>JOINED DATE</th>
            <th>MILESTONE</th>
            <th>STATUS</th>
            <th>RECEIVED INCENTIVE DETAILS</th>
          </tr>
        </thead>
        <tbody>
          {members?.map((member, index) => (
            <tr key={index}>
              <td className="ri-center">
                <strong>{member.sNo}</strong>
              </td>
              <td>
                <div className="ri-product-copy">
                  <strong>{member.memberName || "—"}</strong>
                  <span>{member.memberDetails?.registerId || member.memberId}</span>
                </div>
              </td>
              <td className="ri-center">
                <strong>{member.partnerNetworkId || "—"}</strong>
              </td>
              <td className="ri-center">
                <strong>{member.referringPartnerId || "—"}</strong>
              </td>
              <td>
                <div className="ri-product-copy">
                  <strong>{member.referralUplinerName || "—"}</strong>
                  <span>{member.referralUplinerId || ""}</span>
                </div>
              </td>
              <td className="ri-center">
                <strong>{member.joinedDate || "—"}</strong>
              </td>
              <td className="ri-center">
                <strong>{member.level}</strong>
              </td>
              <td className="ri-center">
                <span className={earningsStatusClass(member.status)}>
                  {statusLabel(member.status)}
                </span>
              </td>
              <td>
                <div className="ri-incentive-lines">
                  <div>
                    <span>Salar Flow Incentives</span>
                    <strong>
                      {formatEarningsCurrency(
                        member.receivedIncentiveDetails?.salarFlowIncentives,
                      )}
                    </strong>
                  </div>
                  <div>
                    <span>
                      TDS
                      {member.receivedIncentiveDetails?.salarFlowTdsPercentage !=
                      null
                        ? ` (${member.receivedIncentiveDetails.salarFlowTdsPercentage}%)`
                        : ""}
                    </span>
                    <strong>
                      {member.receivedIncentiveDetails?.salarFlowTdsAmount !=
                      null
                        ? `- ${formatEarningsCurrency(member.receivedIncentiveDetails.salarFlowTdsAmount)}`
                        : "—"}
                    </strong>
                  </div>
                  <div>
                    <span>Net Flow Incentive</span>
                    <strong>
                      {member.receivedIncentiveDetails?.salarFlowNetIncentive !=
                      null
                        ? formatEarningsCurrency(
                            member.receivedIncentiveDetails.salarFlowNetIncentive,
                          )
                        : "—"}
                    </strong>
                  </div>
                  <div>
                    <span>Salar Pearls Incentives</span>
                    <strong>
                      {formatEarningsCurrency(
                        member.receivedIncentiveDetails?.salarPearlsIncentives,
                      )}
                    </strong>
                  </div>
                </div>
              </td>
            </tr>
          ))}
          {(!members || members.length === 0) && (
            <tr>
              <td colSpan={9} className="ri-center">
                No member data available for this milestone
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReferralCommLevelTable;
